{
    function franceAddressFieldTomSelectSettings(settings) {
        return {
            ...settings,
            searchField: [],
            valueField: 'id',
            labelField: 'text',
            load: function(query, callback) {
                const url =
                    settings.search_api_url +
                    ('?type=' + settings.search_api_results_type) +
                    ('&limit=' + settings.search_api_results_limit) +
                    ('&q=' + encodeURIComponent(query));

                fetch(url)
                    .then((response) => response.json())
                    .then((json) => {
                        const data = json.features.map((item) => {
                            return {
                                id: JSON.stringify(item),
                                text: item?.properties?.label,
                                data: item,
                            };
                        });

                        this.clearOptions();
                        callback(data);
                    })
                    .catch(() => {
                        callback();
                    });
            },
        };
    }

    window.franceAddressFieldTomSelectSettings = franceAddressFieldTomSelectSettings;
}
